<template>
  <v-row
    ref="wrapper"
    v-resize="onResize"
    class="fill-height"
    no-gutters
  >
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn
            outlined
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
          >
            Today
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              arrow_back_ios
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              arrow_forward_ios
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer />
          <Search />
          <v-menu
            bottom
            right
          >
            <template #activator="{ on, attrs }">
              <v-btn
                outlined
                color="grey darken-2"
                v-bind="attrs"
                class="ml-4"
                v-on="on"
              >
                <span>{{ views[view].text }}</span>
                <v-icon right>
                  expand_more
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(v, i) in views"
                :key="v.text"
                @click="view = i"
              >
                <v-list-item-title>{{ v.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet :height="height">
        <v-progress-linear
          :active="loading"
          indeterminate
        />
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          event-overlap-mode="column"
          :events="appointments"
          :type="type"
          interval-height="65"
          :weekdays="weekdays"
          @click:event="eventClick"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="dateRangeChange"
        >
          <template #event="{ event, eventSummary }">
            <div>
              <div
                class="px-1"
                :style="
                  event.status === 'canceled' && 'text-decoration: line-through'
                "
                v-html="eventSummary()"
              />
              <v-row
                no-gutters
                class="fill-height mx-1"
              >
                <v-col class="px-1">
                  <v-chip
                    v-if="
                      event.status !== 'canceled' ||
                        (event.status === 'canceled' &&
                          event._paid)
                    "
                    small
                    :color="chipColor(event)"
                    :outlined="!event._paid"
                    class="mr-2"
                  >
                    <v-icon
                      left
                      :color="chipIconColor(event)"
                    >
                      paid
                    </v-icon>
                    {{ _paymentStatus(event.paymentStatus || "pending").text }}
                  </v-chip>
                  <v-chip
                    v-if="event.status === 'canceled'"
                    small
                    :color="chipColor(event)"
                    :outlined="!event._paid"
                  >
                    <v-icon
                      left
                      :color="chipIconColor(event)"
                    >
                      event
                    </v-icon>
                    {{ _appointmentStatus(event.status).text }}
                  </v-chip>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";
import mixins from "./mixins";
import Search from "./Search.vue";
import { db } from '@/plugins/firebase'

export default {
  components: {
    Search,
  },
  mixins: [mixins, helpers, binder],
  data: () => ({
    height: 800,
    focus: "",
    viewRange: {
      start: new Date().toISOString(),
      end: null
    },
    loading: false,
    appointments: [],
    view: 2,
    views: [
      { text: "Month", type: "month", weekdays: [1, 2, 3, 4, 5] },
      { text: "Week (full)", type: "week", weekdays: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Week (mon-fri)", type: "week", weekdays: [1, 2, 3, 4, 5] },
      { text: "Day", type: "day", weekdays: [1, 2, 3, 4, 5, 6, 0] },
    ],
  }),
  computed: {
    events() {
      // eslint-disable-next-line no-unused-vars
      return this.appointments.map(({ color, ...a }) => a);
    },
    type() {
      return this.views[this.view].type;
    },
    weekdays() {
      return this.views[this.view].weekdays;
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.$refs.calendar.scrollToTime("06:55");
  },
  methods: {
    bindEvents(start, end) {
      start = (new Date(`${start} 00:00:00`.replace(/-/g, "/"))).toISOString()
      end = (new Date(`${end} 23:59:59`.replace(/-/g, "/"))).toISOString()
      const callback = (data) => {
        this.appointments = this._mutateAppointments(data);
      };

      const dbRef = db
        .collection("services/consulting/appointments")
        .where('start', '>=', start) 
        .where('start', '<=', end) 

      this.$bindDb("appointments", dbRef, { callback, loader: "loading" });
    },
    viewDay({ date }) {
      this.focus = date;
      this.viewType = "day";
    },
    eventClick(e) {
      this.$router.push(`/consulting/${e.event.id}`);
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    dateRangeChange(e) {
      this.bindEvents(e.start.date, e.end.date )
    },
    onResize() {
      if (this.$refs.wrapper) {
        let { y } = this.$refs.wrapper.getBoundingClientRect();
        this.height = window.innerHeight - y - 64;
      }
    },
    chipColor(event) {
      return event.status === "canceled" && event._paid
        ? "error"
        : "white";
    },
    chipIconColor(event) {
      return event.status === "canceled" && event._paid
        ? "white"
        : event._paid
        ? "success"
        : "white";
    },
  }
};
</script>
<style lang="css" scoped>
</style>
